import { MapContainer, TileLayer, Marker, Popup, useMap, Tooltip } from 'react-leaflet'
import * as L from "leaflet"
import { useGetLocationsQuery } from './api/locationsApiSlice';
import Loading from 'components/commons/Loading';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function GlobalMap() {

    const [t] = useTranslation("global")

    // API
    const {
        data,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetLocationsQuery()

    let content
    let minimumLocations


    const defaultLat = 41.902782
    const defaultLong = 12.496366
    const starterZoom = 8 //12 ok

    var markerSize = { 'sm': [28, 35], 'md': [35, 44], 'lg': [42, 53] };
    var markerAnchor = { 'sm': [14, 35], 'md': [17, 44], 'lg': [21, 53] };
    var markerPopupAnchor = { 'sm': [1, -35], 'md': [1, -44], 'lg': [2, -53] };

    //  Create the Icon
    const LeafIcon = L.Icon.extend({
        options: {}
    });

    const blueIcon = new LeafIcon({
        iconUrl:
            "https://assets.mapquestapi.com/icon/v2/marker-B@2x.png"
    })

    function getMarkerIcon(location) {

        let pinBackgroundColor

        switch (location.type) {
            case "BUSINESS_UNIT":
                pinBackgroundColor = "2bb673"
                break
            case "ALARM_SOURCE":
                pinBackgroundColor = "red"
                break
            default: pinBackgroundColor = "2bb673"
        }

        return new LeafIcon({
            iconUrl: `https://assets.mapquestapi.com/icon/v2/marker-lg-2c363c-${pinBackgroundColor}-${location.name}.png`,
            iconSize: markerSize.lg,
            iconAnchor: markerAnchor.lg,
            popupAnchor: markerPopupAnchor.lg
        })
    }

    function getDestination(location) {
        switch (location.type) {
            case "BUSINESS_UNIT": return "/dashboard/businessUnits/detail"
            case "ALARM_SOURCE": return "/dashboard/safety/dashboard"
            default: return
        }
    }

    if (isSuccess) {

        minimumLocations = data.length > 0


        const mapBounds = [
            [Math.max(...data.map(l => l.latitude)), Math.min(...data.map(l => l.longitude))],
            [Math.min(...data.map(l => l.latitude)), Math.max(...data.map(l => l.longitude))]
        ]

        content = <div className=" px-4 mt-4">
            <div className="full-screen-map">
                <MapContainer
                    bounds={minimumLocations ? mapBounds : null}
                    boundsOptions={{ padding: [100, 100] }}
                    center={minimumLocations ? null : [defaultLat, defaultLong]}
                    zoom={minimumLocations ? null : starterZoom}
                    scrollWheelZoom={true}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    {data && data.map(location => (
                        <Marker position={[location.latitude, location.longitude]} icon={new getMarkerIcon(location)} key={location.guid}>
                            <Tooltip><b>{location.name}</b></Tooltip>
                            <Popup>
                                <small className="text-muted">{[location.code]}</small>
                                <h4>{[location.name]}</h4>
                                <p className="">
                                    {location.description}
                                </p>

                                <NavLink to={getDestination(location)} state={location} className="btn-primary btn text-white"><i className="fa-solid fa-eye" ></i> {t("action.see")}</NavLink>
                            </Popup>
                        </Marker>

                    ))}


                </MapContainer>
            </div>

        </div>
    } else content = <Loading />

    return content
}

export default GlobalMap